<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('USDR闪兑.USDR闪兑')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="swap-item1-bg-image p-40">
					<div class="flex items-center justify-between">
						<div class="flex items-center">
							<span class="text-40 font-bold text-white">USDR</span>
							<img class="mx-20 w-28 h-28" src="@/assets/images/pages/swap/qh.png" alt="" />
							<span class="text-40 font-bold text-white">ROON {{$t('闪兑.闪兑')}}</span>
						</div>
						<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
							style="border-color: #EB470C; background-color: #EB470C20;">
							<div class="w-8 h-8 rounded-full" style="background-color: #EB470C;"></div>
							<span class="ml-10 text-20" style="color: #EB470C;">{{$t('USDR闪兑.极速闪兑')}}</span>
						</div>
					</div>
					<div class="mt-20">
						<span class="text-24 text-#ccc">{{$t('USDR闪兑.快速兑换 · 安全可靠')}}</span>
					</div>
					<div class="mt-30 flex items-center">
						<img class="w-22 h-22" src="@/assets/images/pages/swap/sd.png" alt="" />
						<span class="ml-10 text-24 text-#ccc">{{$t('闪兑.极速闪兑')}}</span>
						<img class="ml-20 w-22 h-22" src="@/assets/images/pages/swap/aq.png" alt="" />
						<span class="ml-10 text-24 text-#ccc">{{$t('闪兑.安全可靠')}}</span>
					</div>
				</div>
                <div class="mt-30 flex items-center justify-between">
                    <div class="swap-item3-bg-image  p-30">
                        <div class="flex items-center justify-between">
                            <span class="text-24 text-#ccc">USDR{{$t("USDR闪兑.余额")}}</span>
                            <img class="w-50 h-50" src="@/assets/images/common/icon_usdr.png" alt="" />
                        </div>
                        <div class="mt-10">
                            <span class="text-46 font-bold" style="color: #EB470C;">{{usdr_balance}}</span>
                        </div>
                        <!-- 充值/提现按钮并排显示（使用内联样式保证间距与宽度生效） -->
                        <div class="mt-20 flex items-center" style="gap: 16px; flex-wrap: nowrap;">
                            <div @click="recharge(1)" class="h-76 rounded-12 flex items-center justify-center border border-solid" style="border-color: #EB470C; background-color: #EB470C20; width: 60px; flex-shrink: 0;">
<!--                                <img class="w-40 h-40 mr-10" src="@/assets/images/common/wallet.png" alt="" />-->
                                <span class="text-28 text-#eee">充值</span>
                            </div>
                            <div @click="showTx(1)" class="h-76 rounded-12 flex items-center justify-center border border-solid" style="border-color: #EB470C; background-color: #EB470C20; width: 60px; flex-shrink: 0;">
<!--                                <img class="w-40 h-40 mr-10" src="@/assets/images/common/wallet.png" alt="" />-->
                                <span class="text-28 text-#eee">{{$t("USDR闪兑.提现")}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="swap-item3-bg-image  p-30">
                        <div class="flex items-center justify-between">
                            <span class="text-24 text-#ccc">ROON{{$t("USDR闪兑.余额")}}</span>
                            <img class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
                        </div>
                        <div class="mt-10">
                            <span class="text-46 font-bold" style="color: #EB470C;">{{roon_balance}}</span>
                        </div>
                        <div @click="showTx(2)" class="mt-20 w-260 h-76 rounded-12 flex items-center justify-center border border-solid" style="border-color: #EB470C; background-color: #EB470C20;">
                            <img class="w-40 h-40 mr-10" src="@/assets/images/common/wallet.png" alt="" />
                            <span class="text-28 text-#eee">{{$t("USDR闪兑.提现")}}</span>
                        </div>
                    </div>
                </div>
				<div class="mt-20 bg-white/10 rounded-20 p-20 flex items-center">
					<img class="w-40 h-40" src="@/assets/images/pages/usdr-swap/icon_sd.png" alt="" />
					<div class="ml-20 flex-1">
						<div class="flex items-center justify-between">
							<div>
								<span class="text-28 text-white">{{$t("闪兑.闪兑比例")}}</span>
							</div>
							<div>
								<span class="text-36 font-bold" style="color: #EB470C">1:{{roon_price}}</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div>
								<span class="text-30 font-blod" style="color: #EB470C">1USDR = {{roon_price}}ROON</span>
							</div>
							<div>
								<span class="text-24 text-#ccc">{{$t("USDR闪兑.实时汇率")}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30">
					<div class="">
						<span class="text-36 text-white font-bold">{{$t("闪兑.闪兑数量")}}</span>
					</div>
					<div class="mt-20 h-110 rounded-20 flex items-center justify-between px-30" style="background-color: #0F0F10;">
						<input class="flex-1 text-32 text-white" v-model="form.amount" @input="handleInputTwo" type="text" :placeholder="$t('USDR闪兑.输入USDR数量')" />
						<span class="text-32 text-primary" style="color: #EB470C;">USDR</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="flex items-center">
							<span class="text-24 text-#999">{{$t("闪兑.余额")}}</span>
							<span class="text-24" style="color: #EB470C;">{{usdr_balance}}  USDR</span>
						</div>
					</div>
<!--					<div class="mt-20 flex items-center justify-between">-->
<!--						<div @click="selectAmount(item.num)" v-for="(item, index) in numberList" :key="index"-->
<!--							:class="[form.amount == item.num ? 'bg-primary text-white' : 'bg-#1B1B1B text-#ccc']"-->
<!--							class="w-110 h-80 rounded-20 flex items-center justify-center ">-->
<!--							<span class="text-28">{{item.num}}</span>-->
<!--						</div>-->
<!--					</div>-->
					<div class="mt-30 rounded-20 bg-white/10 py-30 flex items-center justify-center">
						<div>
							<div class="flex items-center justify-center">
								<span class="text-24 text-#999">{{$t('闪兑.将获得')}}</span>
							</div>
							<div class="flex items-start justify-center mt-20">
								<div class="text-right">
									<div>
										<span class="text-50 font-bold" style="color: #EB470C">{{form.amount}}</span>
									</div>
									<div>
										<span class="text-26 " style="color: #EB470C">USDR</span>
									</div>
								</div>
								<img class="mx-30 w-50 h-50" src="@/assets/images/pages/swap/hz.png" alt="" />
								<div class="text-left">
									<div>
										<span class="text-50 font-bold" style="color: #EB470C">{{form.dd_roon}}</span>
									</div>
									<div>
										<span class="text-26 " style="color: #EB470C">ROON</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-center">
						<div @click="swap"
							class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
							<span class="text-32 text-white">{{$t('闪兑.立即闪兑')}}</span>
						</div>
					</div>
				</div>
				<div class=" my-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('USDR闪兑.闪兑记录')}}</span>
					</div>
					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']" class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('USDR闪兑.提现记录')}}</span>
					</div>
				</div>
				<div v-if="queryInfo.type == 1" class="mt-30 bg-white/10 rounded-20 p-30">
					<div class="mb-30">
						<span class="text-36 text-white">{{$t("USDR闪兑.闪兑记录")}}</span>
					</div>
					<div v-for="(item, index) in excharge_log" :key="index" class="mb-20 p-30 bg-white/10 rounded-20">
						<div class="flex items-center justify-between">
							<div class="w-70 h-70">
								<img class="w-full h-full" src="@/assets/images/pages/usdr-swap/icon_xxjs.png" alt="" />
							</div>
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-white text-24">{{$t("USDR闪兑.兑换成功")}}</span>
									<div class="px-20 h-42 flex items-center justify-center rounded-12 border border-solid" style="border-color: #11EB0C; background-color: #11EB0C20;">
										<span class="text-white text-22">{{$t("USDR闪兑.已完成")}}</span>
									</div>
								</div>
								<div class="mt-10">
									<span class="text-#999 text-20">{{item.created_at}}</span>
								</div>
							</div>
						</div>
						<div class="flex items-center justify-between mt-20">
							<div class="flex-1 mr-10 bg-white/10 rounded-20 p-30">
								<div class="">
									<span class="text-20 text-#999">{{$t("USDR闪兑.消耗")}}USDR</span>
								</div>
								<div class="mt-20">
									<span class="text-36 text-primary font-blod">{{item.value}}</span>
								</div>
							</div>
							<div class="flex-1 ml-10 bg-white/10 rounded-20 p-30">
								<div class="">
									<span class="text-20 text-#999">{{$t("USDR闪兑.获得")}}ROON</span>
								</div>
								<div class="mt-20">
									<span class="text-36 text-primary font-blod">{{item.remark}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="mt-30  bg-white/10 rounded-20 p-30">
					<div class="mb-30">
						<span class="text-36 text-white">{{$t("USDR闪兑.提现记录")}}</span>
					</div>
					<div v-for="(item, index) in withdrawal_list" :key="index" class="mb-20 p-30 bg-white/10 rounded-20">
						<div class="flex items-center justify-between">
							<div class="w-70 h-70">
								<img class="w-full h-full" src="@/assets/images/pages/usdr-swap/icon_tx.png" alt="" />
							</div>
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-white text-24">{{item.field_name}}{{$t("USDR闪兑.提现")}}</span>
									<div v-if="item.status == 0" class="px-20 h-42 flex items-center justify-center rounded-12 border border-solid" style="border-color: #EB850C; background-color: #EB850C20;">
										<span class="text-white text-22">{{$t("USDR闪兑.处理中")}}</span>
									</div>
									<div v-else class="px-20 h-42 flex items-center justify-center rounded-12 border border-solid" style="border-color: #11EB0C; background-color: #11EB0C20;">
										<span class="text-white text-22">{{$t("USDR闪兑.已完成")}}</span>
									</div>
								</div>
								<div class="mt-10">
									<span class="text-#999 text-20">{{item.created_at}}</span>
								</div>
							</div>
						</div>
						<div class="flex items-center justify-between mt-20">
							<div class="flex-1 mr-10 bg-white/10 rounded-20 p-30">
								<div class="">
									<span class="text-20 text-#999">{{$t("USDR闪兑.提现金额")}}</span>
								</div>
								<div class="mt-20">
									<span class="text-36 text-primary font-blod">{{item.money}}</span>
								</div>
							</div>
							<div class="flex-1 ml-10 bg-white/10 rounded-20 p-30">
								<div class="">
									<span class="text-20 text-#999">{{$t("USDR闪兑.提现地址")}}</span>
								</div>
								<div class="mt-20">
									<span class="text-36 text-white font-blod">{{show_address}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30 px-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-between mt-20">
							<span v-if="form.type == 1" class="text-36 text-white">USDR{{$t("USDR闪兑.提现")}}</span>
							<span v-else class="text-36 text-white">ROON{{$t("USDR闪兑.提现")}}</span>
							<img @click="showAmountPopup = false" class="w-40 h-40" src="@/assets/images/pages/usdr-swap/icon_gb.png" alt="" />
						</div>
						<div class="flex items-center mt-20">
							<span class="text-26 text-#999">{{$t("USDR闪兑.可用余额")}}</span>
							<span class="text-26 text-primary ml-20" v-if="form.type == 1">{{usdr_balance}}</span>
							<span class="text-26 text-primary ml-20" v-else>{{roon_balance}}</span>
						</div>
						<div class="mt-20">
							<span class="text-26 text-#999">{{$t("USDR闪兑.提现数量")}}</span>
						</div>
						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
                            <input class="flex-1 text-32 text-white" v-model="withdrawal_number" @input="handleWithdrawalInput" type="text" inputmode="decimal" :placeholder="$t('USDR闪兑.请输入数量')" />
							<img v-if="form.type == 1" class="w-50 h-50" src="@/assets/images/common/icon_usdr.png" alt="" />
							<img v-else class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
						</div>
<!--						<div class="mt-20">-->
<!--							<span class="text-26 text-#999">{{$t("USDR闪兑.提现地址")}}</span>-->
<!--						</div>-->
<!--						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">-->
<!--							<input class="flex-1 text-32 text-white" type="text" :placeholder="$t('USDR闪兑.输入钱包地址')" />-->
<!--						</div>-->
						<div class="mt-40 flex items-center justify-center">
							<div @click="withdrawal" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
							</div>
						</div>
					</div>
				</div>
			</van-popup>


            <van-popup v-model="rechargePopup" position="center" round>
                <div class="w-690">
                    <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30 px-30" style="margin-top: -98rem;">
                        <div class="flex items-center justify-between mt-20">
                            <span v-if="form.type == 1" class="text-36 text-white">USDR{{$t("充值")}}</span>
                            <span v-else class="text-36 text-white">ROON{{$t("充值")}}</span>
                            <img @click="rechargePopup = false" class="w-40 h-40" src="@/assets/images/pages/usdr-swap/icon_gb.png" alt="" />
                        </div>
<!--                        <div class="flex items-center mt-20">-->
<!--                            <span class="text-26 text-#999">{{$t("USDR闪兑.可用余额")}}</span>-->
<!--                            <span class="text-26 text-primary ml-20" v-if="form.type == 1">{{usdr_balance}}</span>-->
<!--                            <span class="text-26 text-primary ml-20" v-else>{{roon_balance}}</span>-->
<!--                        </div>-->
                        <div class="mt-20">
                            <span class="text-26 text-#999">{{$t("USDR闪兑.充值数量")}}</span>
                        </div>
                        <div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
                            <input class="flex-1 text-32 text-white" v-model="recharge_number" @input="handleRecharge" type="text" inputmode="decimal" :placeholder="$t('USDR闪兑.请输入数量')" />
                            <img v-if="form.type == 1" class="w-50 h-50" src="@/assets/images/common/icon_usdr.png" alt="" />
                            <img v-else class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
                        </div>
                        <!--						<div class="mt-20">-->
                        <!--							<span class="text-26 text-#999">{{$t("USDR闪兑.提现地址")}}</span>-->
                        <!--						</div>-->
                        <!--						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">-->
                        <!--							<input class="flex-1 text-32 text-white" type="text" :placeholder="$t('USDR闪兑.输入钱包地址')" />-->
                        <!--						</div>-->
                        <div class="mt-40 flex items-center justify-center">
                            <div @click="doRecharge" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
                                <span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>

			<!-- 不可关闭的 Loading 遮罩：发起兑换接口后显示，接口有响应则关闭 -->
			<van-overlay :show="swapping" :z-index="100000" lock-scroll>
				<div class="w-full h-full flex items-center justify-center">
					<div class="px-40 py-30 bg-#1B1B1B rounded-20 flex items-center">
						<van-loading type="spinner" color="#EB470C" size="28px" />
						<span class="ml-16 text-28 text-white">Loading…</span>
					</div>
				</div>
			</van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
    import TokenDepositAbi from "@/abi/TokenDepositAbi"
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
				node_allocate: 0,
				node_release: 0,
				node_low_pool: 1995,
				node_day: 0,
				node_number: 0,
                roon_number: 0,
				node_has: 0,
				node_price: 0,
                roon_price: 0,
                withdrawal_number: 0,
                recharge_number: 0,
				node_progress: 0,
				node_surplus_number: 0,
				last_pledge_id: 0,
				last_pledge_time: "",
                total_address: "",
                roon_balance: "",
                usdr_balance: "",
				mining_contract: "",
				last_pledge_usdt: "",
				last_pledge_name: "",
				address: "",
				show_address: "",
				order_id: "",
				users_id: "",
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
                roon_usdr: "0xb5b97bA656A523Af73427203B01BEa94ea94E652",
                usdr_contract_address: "0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
				web3Provider: null,
				web3: null,
				list: [],
                withdrawal_list: [],
                amountList: [],
                excharge_log: [],
                showAmountPopup: false,
                rechargePopup: false,
                // 闪兑进行中的不可关闭 loading 遮罩
                swapping: false,
                canGo: true,
                form: {
                    type: 1,
                    amount: 0,
                    dd_roon: 0,
					amount_id: 0
				},
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: 1
					},
					{
						id: 2,
						num: 2
					},
					{
						id: 3,
						num: 3
					},
					{
						id: 4,
						num: 4
					},
					{
						id: 5,
						num: 5
					},

				]
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);
			}
			vm.getList();
		},
        methods: {
            // 充值入口（占位行为）：根据类型提示用户进行充值
            // type: 1 = USDR, 2 = ROON
            recharge(type){
                const vm = this;
                // const tokenName = type === 1 ? 'USDR' : 'ROON';

                vm.rechargePopup = true
            },
            async doRecharge(){
                let vm = this
                try {
                    const num = parseFloat(vm.recharge_number);
                    if (!Number.isFinite(num) || num <= 0) {
                        vm.$message.error("请先输入金额");
                        return;
                    }
                    // 校验当前网络是否为 ROON 主链（chainId = 1314520）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error("请切换到 ROON 主链");
                        return;
                    }

                    // 统一从钱包拉取当前账户，兼容 TokenPocket/MetaMask/OKX
                    let walletAccount = null;
                    try {
                        if (window?.ethereum?.request) {
                            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        } else {
                            const accounts = await vm.web3.eth.getAccounts();
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        }
                    } catch (e) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    if (!walletAccount) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    // 使用钱包当前账户作为交易发起方
                    vm.address = walletAccount;

                    const decimals = 18;

                    // 参数：第一个为用户输入值 vm.num；第二个为目的链标识 vm.to.id
                    const rawAmountStr = String(num).trim();
                    const toChainIdParam = 1;

                    // 构造合约实例
                    const depositContract = new vm.web3.eth.Contract(TokenDepositAbi, vm.roon_usdr);
                    const tokenContract = new vm.web3.eth.Contract(erc20Abi, vm.usdr_contract_address);
                    // 授权的 spender 为存款合约地址（之前从 Kua.vue 复制的 vm.from.deposit_address 不存在）
                    const spenderAddress = vm.roon_usdr;

                    // 规范化输入，如 .5 -> 0.5
                    const normalizedAmountStr = rawAmountStr.startsWith('.') ? `0${rawAmountStr}` : rawAmountStr;

                    // 将字符串金额按链精度转换为基础单位（BN字符串）
                    const amountBase = (function toBaseUnits(amountStr, decimals) {
                        const parts = amountStr.split('.');
                        const intPart = (parts[0] || '0').replace(/^0+(?=\d)/, '');
                        const fracPartRaw = parts[1] || '';
                        const fracPart = fracPartRaw.slice(0, decimals);
                        const fracPadded = fracPart.padEnd(decimals, '0');
                        const factorStr = '1' + '0'.repeat(decimals);
                        const intBN = vm.web3.utils.toBN(intPart || '0');
                        const factorBN = vm.web3.utils.toBN(factorStr);
                        const fracBN = vm.web3.utils.toBN(fracPadded || '0');
                        const scaled = intBN.mul(factorBN).add(fracBN);
                        return scaled.toString();
                    })(normalizedAmountStr, decimals);
                    // 构造 gas 参数（兼容 EIP-1559 与 legacy）
                    async function buildGasOpts(base, forceLegacyTx){
                        const latestBlock = await vm.web3.eth.getBlock('latest');
                        const opts = { ...base };
                        if (!forceLegacyTx && latestBlock && latestBlock.baseFeePerGas) {
                            const baseFeeBN = vm.web3.utils.toBN(latestBlock.baseFeePerGas.toString());
                            let priorityFeeStr = '0';
                            try {
                                const pf = await vm.web3.eth.getMaxPriorityFeePerGas();
                                if (pf) priorityFeeStr = pf.toString();
                            } catch (e) {
                                priorityFeeStr = '0';
                            }
                            const priorityBN = vm.web3.utils.toBN(priorityFeeStr);
                            const maxFeeBN = baseFeeBN.mul(vm.web3.utils.toBN('2')).add(priorityBN);
                            opts.maxFeePerGas = vm.web3.utils.toHex(maxFeeBN);
                            opts.maxPriorityFeePerGas = vm.web3.utils.toHex(priorityBN);
                        } else {
                            const gasPrice = await vm.web3.eth.getGasPrice();
                            opts.gasPrice = vm.web3.utils.toHex(gasPrice);
                            opts.type = '0x0';
                        }
                        return opts;
                    }

                    // 基于 pending 计数获取安全 nonce，并在遇到 nonce 错误时自动重试
                    async function getSafeNonce() {
                        let n;
                        try {
                            n = await vm.web3.eth.getTransactionCount(vm.address, 'pending');
                        } catch (e) {
                            n = await vm.web3.eth.getTransactionCount(vm.address, 'latest');
                        }
                        return typeof n === 'number' ? n : parseInt(n);
                    }

                    async function sendTxWithRetry(method, opts, initialNonce, retries = 3) {
                        let nonce = initialNonce;
                        for (let i = 0; i <= retries; i++) {
                            try {
                                const prom = new Promise((resolve, reject) => {
                                    method
                                        .send({ ...opts, nonce })
                                        .on('transactionHash', (hash) => {
                                            console.log('txHash:', hash);
                                        })
                                        .on('receipt', (receipt) => {
                                            resolve(receipt);
                                        })
                                        .on('error', (err) => {
                                            reject(err);
                                        });
                                });
                                const rcpt = await prom;
                                return rcpt;
                            } catch (err) {
                                const msg = (err?.data?.originalError?.message || err?.data?.message || err?.message || '').toLowerCase();
                                // 针对 nonce 冲突或替换相关错误，重新获取 pending nonce 后重试
                                if (msg.includes('nonce') || msg.includes('replacement') || msg.includes('too low')) {
                                    try {
                                        nonce = await getSafeNonce();
                                        continue;
                                    } catch (e) {}
                                }
                                throw err;
                            }
                        }
                        throw new Error('交易发送失败（nonce 重试耗尽）');
                    }

                    try {
                        // 1) 估算 approve gas 并构建交易参数
                        let approveGas = await tokenContract.methods
                            .approve(spenderAddress, amountBase)
                            .estimateGas({ from: vm.address });
                        approveGas = Math.ceil(Number(approveGas) * 1.3);
                        const approveOpts = await buildGasOpts({ from: vm.address, gas: approveGas }, true);

                        // 开始授权前，显示不可取消的加载层
                        vm.swapping = true;

                        // 获取安全 nonce 并发送授权交易（遇到 nonce 冲突自动重试）
                        const initialNonce = await getSafeNonce();
                        await sendTxWithRetry(
                            tokenContract.methods.approve(spenderAddress, amountBase),
                            approveOpts,
                            initialNonce,
                        );

                        // 2) 授权成功后再调用合约的 deposit(amountBase, toChainIdParam)
                        let depGas = await depositContract.methods
                            .deposit(amountBase, toChainIdParam)
                            .estimateGas({ from: vm.address });
                        depGas = Math.ceil(Number(depGas) * 1.3);
                        const depOpts = await buildGasOpts({ from: vm.address, gas: depGas }, true);

                        // 使用下一个 nonce（或重新获取 pending nonce）发送存款交易
                        let nextNonce = initialNonce + 1;
                        try {
                            const pendingNow = await getSafeNonce();
                            nextNonce = Math.max(nextNonce, pendingNow);
                        } catch {}

                        await sendTxWithRetry(
                            depositContract.methods.deposit(amountBase, toChainIdParam),
                            depOpts,
                            nextNonce,
                        );

                        // 成功后关闭加载层与弹窗
                        vm.swapping = false;
                        vm.rechargePopup = false;
                        vm.$message.success(vm.$t("吐司.操作成功请稍后刷新查看"));
                    } catch (e) {
                        vm.swapping = false;
                        const original = e?.data?.originalError?.message || e?.data?.message || e?.message;
                        const msg = (original || '').toLowerCase();
                        if (msg.includes('nonce') || msg.includes('不能小于') || msg.includes('too low')) {
                            vm.$message.error("钱包交易序号冲突，请等待前一笔上链或稍后重试");
                        } else {
                            vm.$message.error(`操作失败: ${original || e}`);
                        }
                    }

                } catch (err) {
                    // 输出更详细的 RPC 错误信息，便于定位问题
                    const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                    console.error('交易失败:', err);
                    vm.$message.error(original || utils.$t("吐司.操作失败"));
                    vm.swapping = false;
                }
            },
            // 提现数量输入：仅允许数字和一个小数点
            handleWithdrawalInput(){
                const vm = this;
                let val = String(vm.withdrawal_number ?? "");
                // 仅保留数字和小数点
                val = val.replace(/[^\d.]/g, '');
                // 仅保留第一个小数点
                const dotIndex = val.indexOf('.');
                if (dotIndex !== -1) {
                    val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '');
                }
                // 若以小数点开头，补零
                if (val.startsWith('.')) val = '0' + val;
                vm.withdrawal_number = val;
            },
            handleRecharge(){
                const vm = this;
                let val = String(vm.recharge_number ?? "");
                // 仅保留数字和小数点
                val = val.replace(/[^\d.]/g, '');
                // 仅保留第一个小数点
                const dotIndex = val.indexOf('.');
                if (dotIndex !== -1) {
                    val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '');
                }
                // 若以小数点开头，补零
                if (val.startsWith('.')) val = '0' + val;
                vm.recharge_number = val;
            },
            async withdrawal(){
                const vm = this;
                try {
                    const num = parseFloat(vm.withdrawal_number);
                    if (!Number.isFinite(num) || num <= 0) {
                        vm.$message.error("请先输入金额");
                        return;
                    }

                    if (!vm.web3 || !vm.address) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 校验当前网络是否为 ROON 主链（chainId = 1314520）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error("请切换到 ROON 主链");
                        return;
                    }

                    // 统一从钱包拉取当前账户，兼容 TokenPocket/MetaMask/OKX
                    let walletAccount = null;
                    try {
                        if (window?.ethereum?.request) {
                            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        } else {
                            const accounts = await vm.web3.eth.getAccounts();
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        }
                    } catch (e) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    if (!walletAccount) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    // 使用钱包当前账户作为交易发起方
                    vm.address = walletAccount;

                    // 纯地址转账：仅 from/to/value，不携带任何合约数据
                    const recipient = vm.total_address;
                    if (!recipient) {
                        vm.$message.error(utils.$t("吐司.收款地址无效"));
                        return;
                    }
                    let amountEth = parseFloat(vm.roon_number);
                    const weiValue = vm.web3.utils.toWei(amountEth.toString(), 'ether');

                    let field = ""
                    if (vm.form.type == 1){
                        field = "usdr_balance"
                    }else{
                        field = "roon_balance"
                    }

                    vm.$message.success(utils.$t("吐司.请在钱包确认交易"));
                    // 开启不可关闭的 Loading 遮罩
                    vm.swapping = true;

                    // 一些钱包（如 TokenPocket）对于 gas/gasPrice 更为严格，尽量显式提供
                    let gasPriceHex;
                    try {
                        const gasPrice = await vm.web3.eth.getGasPrice();
                        gasPriceHex = vm.web3.utils.toHex(gasPrice);
                    } catch {
                        gasPriceHex = vm.web3.utils.toHex(vm.web3.utils.toWei('63', 'gwei'));
                    }
                    let gasLimitHex;
                    try {
                        const gas = await vm.web3.eth.estimateGas({ from: vm.address, to: recipient, value: weiValue });
                        gasLimitHex = vm.web3.utils.toHex(gas);
                    } catch {
                        gasLimitHex = vm.web3.utils.toHex(21000);
                    }

                    const txParams = {
                        from: vm.address,
                        to: recipient,
                        value: vm.web3.utils.toHex(weiValue),
                        gasPrice: gasPriceHex,
                        gas: gasLimitHex,
                    };

                    // 使用事件回调：在拿到交易哈希时关闭 loading
                    vm.web3.eth.sendTransaction(txParams)
                        .on('transactionHash', (hash) => {
                            console.log('交易哈希:', hash);

                            ajaxData("/withdrawal/new",{
                                number:num,
                                field:field,
                                hash:hash,
                            }).then(res => {
                                console.log(res)
                                vm.withdrawal_number = 0
                                vm.$message.success("提现成功");
                                vm.showAmountPopup = false
                                vm.getList()
                            }).catch(err => {
                                console.error(err);
                                vm.$message.error(err?.message || "提现失败");
                            }).finally(() => {
                                // 接口有响应（成功或失败）后关闭 Loading
                                vm.swapping = false;
                            })
                        })
                        .on('receipt', (receipt) => {
                            console.log('主币支付成功:', receipt?.transactionHash || receipt);
                        })
                        .on('error', (err) => {
                            const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                            console.error('交易失败:', err);
                            vm.$message.error(original || utils.$t("吐司.购买失败"));
                            vm.swapping = false;
                        });

                } catch (err) {
                    // 输出更详细的 RPC 错误信息，便于定位问题
                    const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                    console.error('交易失败:', err);
                    vm.$message.error(original || utils.$t("吐司.操作失败"));
                    vm.swapping = false;
                }
            },
            swap(){
                const vm = this;
                vm.$message.error("暂未开放");
                return;

                const num = parseFloat(vm.form?.amount);
                if (!Number.isFinite(num) || num <= 0) {
                    vm.$message.error("请先输入金额");
                    return;
                }
                // 兑换 ROON 数量范围校验：最小1ROON，最大5ROON
                const ddRoon = parseFloat(vm.form?.dd_roon);
                console.log(ddRoon)
                if (Number.isFinite(ddRoon)) {
                    if (ddRoon < 1) {
                        vm.$message.error("最小兑换1ROON");
                        return;
                    }
                    if (ddRoon > 5) {
                        vm.$message.error("最多兑换5ROON");
                        return;
                    }
                }
                // 开启不可关闭的 Loading 遮罩
                vm.swapping = true;
                ajaxData("/usdr/roon/swap",{
                    number:num
                }).then(res => {
                    console.log(res)
                    vm.form.amount = 0
                    vm.form.dd_roon = 0
                    vm.$message.success("兑换成功");
                    vm.getList()
                }).catch(err => {
                    console.error(err);
                    vm.$message.error(err?.message || "兑换失败");
                }).finally(() => {
                    // 接口有响应（成功或失败）后关闭 Loading
                    vm.swapping = false;
                })
            },
			// 显示提现
			showTx(type){
				this.form.type = type;
				this.showAmountPopup = true;
			},
			getList() {
				let vm = this
				getShowAddress()
				ajaxData("/usdr/roon").then(res => {
					console.log(res)
					this.excharge_log = res.data.excharge_log;
					this.show_address = res.data.show_address;
					this.withdrawal_list = res.data.withdrawal;
					this.address = res.data.address;
					this.total_address = res.data.total_address;
					this.roon_number = res.data.roon_number;
					this.roon_balance = parseFloat(res.data.roon_balance).toFixed(2);
					this.usdr_balance = res.data.usdr_balance;
					vm.roon_price = parseFloat(res.data.roon_price);
                    //
					// vm.getUserNodePurchaseStatus()
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			async buy() {
				const vm = this;
				try {
					if (!vm.web3 || !vm.address) {
						vm.$message.error(utils.$t("吐司.请在钱包中打包"));
						return;
					}
					if (!vm.mining_contract) {
						vm.$message.error(utils.$t("吐司.合约地址缺失"));
						return;
					}
					let amount = parseFloat(vm.node_price);
					if (isNaN(amount) || amount <= 0) {
						amount = 0.5
					}
					amount = 0.00005
					// if (amount < vm.mining_min) {
					// vm.$message.error(utils.$t("吐司.金额不能低于最低值"));
					// return;
					// }
					const weiValue = vm.web3.utils.toWei(amount.toString(), 'ether');
					const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
					let gas;
					try {
						gas = await contract.methods.purchaseNode(vm.node_number).estimateGas({
							from: vm.address,
							value: weiValue
						});
					} catch (e) {
						gas = undefined; // 估算失败则让钱包自行估算
					}
					vm.$message.success(utils.$t("吐司.请在钱包确认交易"));
					await contract.methods.purchaseNode(vm.node_number).send({
						from: vm.address,
						value: weiValue,
						gas
					});
					vm.$message.success(utils.$t("吐司.购买成功"));
					// 可选：购买成功后刷新数据
					// vm.getIndex();
				} catch (err) {
					console.error(err);
					vm.$message.error(err?.message || utils.$t("吐司.购买失败"));
				}
			},

			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
                let vm = this
                vm.form.amount = number;
                vm.form.amount = parseFloat(vm.form.amount)
                console.log(vm.roon_price)
                vm.form.dd_roon = (vm.form.amount * vm.roon_price).toFixed(2);
				// this.showAmountPopup = false;
			},
            handleInputTwo(){
                const vm = this;
                let val = String(vm.form.amount);
                // 仅保留数字和小数点
                val = val.replace(/[^\d.]/g, '');
                // 仅保留第一个小数点
                const dotIndex = val.indexOf('.');
                if (dotIndex !== -1) {
                    val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '');
                }
                // 更新输入框显示为清洗后的字符串（避免输入阶段被强制为整数）
                vm.form.amount = val;

                const num = parseFloat(val);
                if (isNaN(num)) {
                    vm.form.amount = '';
                    return;
                }
                vm.form.dd_roon = (num * vm.roon_price).toFixed(2);
                // console.log(e)
            },
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.swap-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/swap/img_banner.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item2-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item3-bg-image {
		width: 326rem;
		height: 282rem;
		background-image: url("~@/assets/images/pages/swap/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>
